import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AccountService } from '../../../services/services.module';
import { OpenDialog } from '../../../shared/dialogs/dialog';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';

@Injectable()
export class DisclaimerGuard implements CanActivate {
  constructor(private router: Router, private accountService: AccountService) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    let currentUser = await this.accountService.loadCurrentUserFromServer();
    // await this.accountService.updateDiscalimer({ accept: false });
    if (!currentUser.researchDisclaimerAccepted) {
      OpenDialog(DisclaimerComponent);
    }

    return true;
  }
}
